import { useTranslation } from 'react-i18next';
import {
  Overline,
  SectionBody,
  SectionHeading,
  SectionInner,
} from '../../HostfullyAccountingMarketing.styles';
import { BannerCopy, BuiltInBanner } from './BuiltInSection.styles';

const BuiltInSection = () => {
  const { t } = useTranslation();

  return (
    <BuiltInBanner data-testid="marketing-built-in">
      <SectionInner>
        <BannerCopy>
          <Overline $onDark>
            {t('pageHostfullyAccounting.marketing.builtIn.overline')}
          </Overline>
          <SectionHeading $onDark>
            {t('pageHostfullyAccounting.marketing.builtIn.title')}
          </SectionHeading>
          <SectionBody $onDark>
            {t('pageHostfullyAccounting.marketing.builtIn.description')}
          </SectionBody>
        </BannerCopy>
      </SectionInner>
    </BuiltInBanner>
  );
};

export default BuiltInSection;
